import RecordType from 'data/RecordType';
import AsyncRecorder from './AsyncRecorder';
import { RecorderEvent } from './Recorder';
import toWav from 'audiobuffer-to-wav';
import { iOSWrapperHasMessageHandlers, postMessageToIosWrapper } from 'utils';

var bufferToBase64 = function (buffer: ArrayBuffer) {
  var bytes = new Uint8Array(buffer);
  var len = buffer.byteLength;
  var binary = '';
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

const canRecord = (): boolean => {
  return iOSWrapperHasMessageHandlers([
    'startRecording',
    'addAudio',
    'addFrame',
    'finishRecording'
  ]);
};

export class IosRecorder extends AsyncRecorder {
  audioBuffer: AudioBuffer | null;
  type = RecordType.VideoAsync;

  constructor(
    canvas: HTMLCanvasElement,
    framesNumber: number,
    duration: number,
    audioBuffer: AudioBuffer | null,
    offlineFrequencies: Uint8Array[] | null,
    offlineWaveforms: Uint8Array[] | null
  ) {
    super(canvas, framesNumber, duration, offlineFrequencies, offlineWaveforms);

    if (!canRecord()) {
      throw new Error('iOS wrapper code not exposed');
    }

    this.audioBuffer = audioBuffer;

    const width = canvas.width;
    const height = canvas.height;

    postMessageToIosWrapper('startRecording', {
      width: `${width}`,
      height: `${height}`,
      mode: 'async'
    });

    if (this.audioBuffer) {
      let wav = toWav(this.audioBuffer);
      var audioURL = bufferToBase64(wav);
      postMessageToIosWrapper('addAudio', {
        audioURL
      });
    }
  }

  update(): void {
    if (this._currentFrame === this.framesNumber) {
      return;
    }
    postMessageToIosWrapper('addFrame', {
      imageURL: this.canvas.toDataURL().split(',')[1]
    });
    this._currentFrame++;
    if (this._currentFrame === this.framesNumber) {
      this.didComplete();
    }
  }

  didComplete() {
    this.emit(RecorderEvent.RecordingEnded);
    postMessageToIosWrapper('finishRecording', {
      cancelled: 'false'
    });
  }

  cancel() {
    super.cancel();

    postMessageToIosWrapper('finishRecording', {
      cancelled: 'true'
    });
  }
}



// WEBPACK FOOTER //
// ./src/video/iOSRecorder.ts